import { asPk, comparePk, type PkLike } from './pkCompare';

/** Lo que el filtro necesita de una fila: sus dos extremos de PK. */
export interface PkRangeItem {
  pkInitKm?: number | null;
  pkInitMeter?: number | null;
  pkEndKm?: number | null;
  pkEndMeter?: number | null;
}

/** Lo que el filtro necesita del cursor: el rango tecleado, quizá a medias. */
export interface PkRangeCursor {
  pkInitKm?: number | null;
  pkInitMeter?: number | null;
  pkEndKm?: number | null;
  pkEndMeter?: number | null;
}

/**
 * «¿El rango de PK de esta fila SOLAPA con el que se ha filtrado?» — la misma
 * semántica que el backend aplica en accidents/campaigns.service.
 *
 * Vive aquí y no dentro de cada loader porque el tab Multimedia se pinta desde
 * DOS sitios (la OT y el recorrido de vigilancia) y el predicado estaba
 * copiado literal en los dos. Copiado, deriva.
 *
 * 🔴 Compara con `comparePk`, nunca con el total `km*1000+metros`: hay
 * kilómetros largos (el 84 de la C-17 mide 1.890 m), y con el total
 * `84+1800` sale por encima de `85+000`, así que el filtro descartaba
 * multimedia que sí entraba en el rango.
 *
 * Los extremos ausentes cuentan como `0`, que es el comportamiento de siempre:
 * un filtro a medias (solo inicio, o solo fin) es media reja, no ninguna.
 */
export const matchesPkRange = (
  item: PkRangeItem,
  cursor: PkRangeCursor
): boolean => {
  if (cursor.pkInitKm == null && cursor.pkEndKm == null) return true;

  const itemInit: PkLike = asPk(item.pkInitKm, item.pkInitMeter);
  const itemEnd: PkLike = asPk(item.pkEndKm, item.pkEndMeter);

  if (cursor.pkInitKm != null) {
    const filterInit = asPk(cursor.pkInitKm, cursor.pkInitMeter);
    if (comparePk(itemEnd, filterInit) < 0) return false;
  }
  if (cursor.pkEndKm != null) {
    const filterEnd = asPk(cursor.pkEndKm, cursor.pkEndMeter);
    if (comparePk(itemInit, filterEnd) > 0) return false;
  }
  return true;
};

export default matchesPkRange;
